import { isNil } from 'lodash';
import userService from 'services/userService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRUserData = Awaited<ReturnType<typeof userService.getUserAsync>>;

const useUser = (userId: number, load = true): SWRResponse<SWRUserData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_USER_ENDPOINT, userId] : null,
    async ([_, orderId]) => await userService.getUserAsync(orderId)
  );

export const SWR_USER_ENDPOINT = 'user';
export default useUser;
